import React from 'react';
import { PageBodyIntro as AbyssPageBodyIntro } from '@uhg-abyss/web/ui/PageBodyIntro';
import { Breadcrumbs } from '@uhg-abyss/web/ui/Breadcrumbs';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { styled } from '@uhg-abyss/web/tools/styled';
import { PageBody } from '@uhg-abyss/web/ui/PageBody';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

interface PageBodyIntroProps {
  title?: string;
  breadcrumbs?: any[]; // Define the type of items if known
  body?: string;
  slot1?: React.ReactNode;
  slot2?: React.ReactNode;
  dataList1?: any[]; // Default to empty array if not provided
  dataList2?: any[]; // Default to empty array if not provided
  subNavLinks?: any[]; // Define the type of subNavLinks if known
}
const AbyssPageBodyIntroBorderBottom = styled(AbyssPageBodyIntro, {
  '&.abyss-page-body-intro-root': {
    marginTop: '0px',
    marginBottom: '0px',
    padding: '0px',
    orderBottom: '1px solid lightgrey',
  },
});

const NoFlexWrapRow = styled(AbyssPageBodyIntro.Row, {
  '&.abyss-page-body-intro-row-container': {
    flexWrap: 'nowrap',
  },
});

const FullWidth = styled(PageBody, {
  '&.abyss-page-body-root': {
    boxShadow: 'lightgrey 0px 1px 10px',
    backgroundColor: 'white',
    '.abyss-page-body-container': {
      maxWidth: '1320px',
      marginLeft: 'auto',
      marginRight: 'auto',
      padding: '0px',
      '@media screen and (max-width: 1380px)': {
        padding: '0px 40px',
      },
    },
  },
});

const StyledBreadcrumbs = styled(Breadcrumbs, {
  '&.abyss-breadcrumb-current': {
    fontWeight: 400,
    fontSize: '12px',
  },
  '&.abyss-breadcrumb-link': {
    fontWeight: 400,
    fontSize: '12px',
  },
});

export const PageBodyIntro = ({
  title,
  breadcrumbs = [],
  body,
  dataList1,
  dataList2,
  slot1,
  slot2,
  subNavLinks = [],
}: PageBodyIntroProps) => {
  const dataSectionContent = (
    <Layout.Stack alignItems="left">
      <AbyssPageBodyIntro.ProfileData profileData={dataList1} />
      <AbyssPageBodyIntro.ProfileData profileData={dataList2} />
    </Layout.Stack>
  );
  const theme = createTheme('uhc', { enterpriseFont: true });
  return (
    <ThemeProvider theme={theme}>
      <FullWidth>
        <AbyssPageBodyIntroBorderBottom>
          {/* Top Row: Breadcrumbs and Actions */}
          <NoFlexWrapRow alignItems="top">
            <Layout.Stack alignItems="left" css={{ width: '100%' }}>
              <If condition={breadcrumbs && breadcrumbs.length > 0}>
                <StyledBreadcrumbs
                  css={{ fontWeight: 400, fontSize: '12px' }}
                  divider={
                    <IconSymbol icon="arrow_right" color="black" size="24px" />
                  }
                  items={breadcrumbs}
                />
              </If>

              <AbyssPageBodyIntro.Title>{title}</AbyssPageBodyIntro.Title>
              <Flex>{body}</Flex>
            </Layout.Stack>

            <Layout.Stack alignItems="right">
              {slot1}
              {slot2}
            </Layout.Stack>
          </NoFlexWrapRow>

          {/* Profile Row */}
          <If condition={dataList1 && dataList1.length > 0}>
            <AbyssPageBodyIntro.Row>
              <AbyssPageBodyIntro.Profile dataSection={dataSectionContent} />
            </AbyssPageBodyIntro.Row>
          </If>
          {/* Links and Required Key Row */}
          <If condition={subNavLinks && subNavLinks.length > 0}>
            <AbyssPageBodyIntro.Row>
              <AbyssPageBodyIntro.Links linkData={subNavLinks} />
            </AbyssPageBodyIntro.Row>
          </If>
        </AbyssPageBodyIntroBorderBottom>
      </FullWidth>
    </ThemeProvider>
  );
};
